import Query from '@/classes/queries/Query'
import { getProjectsSortByOptions } from '@/configurations/general/components-default-data'
import { get as _get, pickBy as _pickBy } from 'lodash'

export default class ProjectQuery extends Query {
  constructor ({ search = null, sort = null, sort_by = null, duration = null, campaign_id, benefiting_id, page = 1, per_page = 1, view_format = null, event_start_date = null, event_end_date = null } = {}) {
    super({ query: { search, sort_by: sort || sort_by, duration, campaign_id, benefiting_id, page, per_page, view_format, event_start_date, event_end_date } })
  }

  get sort_by_field () {
    return _get(getProjectsSortByOptions().find(({ value }) => value === this.sort_by), 'query', {})
  }

  get to_database () {
    return _pickBy({ ...this, ...this.sort_by_field }, (value, key) => value && key !== 'sort_by')
  }
}
